import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';

const FullWidthTextField = styled(TextField)({
  width: '100%',
});

export default FullWidthTextField;
